import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {AddAddressComponent} from '../dialogs/add-address/add-address.component';
import {
  formatTenantAddress,
  NewTenantAddressModel,
  TenantAddressModel
} from '../../models/lab-manager/tenant-address';
import {CustomerModel} from "../../order-to-cash/models-otc/customer-model";
import {AgronimistModel} from "../../models/lab-manager/agronimist";
import {BasicLabManagerItemModel} from "../../models/lab-manager/basic-lab-manager-item";
import {LabSubmissionDetailsModel} from "../../models/lab-manager/lab-submission-details";
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from "@angular/material/core";
import {MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter} from "@angular/material-moment-adapter";
import {LabManagerService} from "../lab-manager.service";
import {LAB_MANAGER_DATE_FORMAT} from "../lab-samples/lab-samples.component";

export interface LabSubmissionDetailsChangeModel  {
  labSubmissionDetails: LabSubmissionDetailsModel;
  isValid: boolean;
}

@Component({
    selector: 'app-lab-submission-detail',
    templateUrl: './lab-submission-detail.component.html',
    styleUrls: ['./lab-submission-detail.component.css'],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: LAB_MANAGER_DATE_FORMAT }
    ],
    standalone: false
})
export class LabSubmissionDetailComponent implements OnInit, OnChanges{

  submissionDetailsForm: FormGroup;
  @Input() customerList: CustomerModel[] = [];
  @Input() isLoadingCustomers: boolean = true;
  @Input() submissionTypes: BasicLabManagerItemModel[] = [];
  capturingChanges: boolean = true;
  @Input() creationDate: string = '';
  currentDate = new Date();
  selectedCustomer: CustomerModel = null;
  representative: any = JSON.parse(sessionStorage.getItem('representative'));
  @Input() agronomistList: AgronimistModel[] = [];
  @Input() labList: BasicLabManagerItemModel[] = [];
  @Input() labSubmissionDetails: LabSubmissionDetailsModel = null;
  @Output() labSubmissionChanges: EventEmitter<LabSubmissionDetailsChangeModel> = new EventEmitter<LabSubmissionDetailsChangeModel>();
  @Output() customerChange: EventEmitter<CustomerModel> = new EventEmitter<CustomerModel>();
  filteredAgronomistList: AgronimistModel[] = [];
  @Input() hasOneAnalysis: boolean = false;
  @Input() hasOneSample: boolean = false;
  @Input() labHasSamples: boolean = false;


  agronomistFilterCtrl: FormControl<string> = new FormControl<string>('');
  filteredClientList: CustomerModel[] = [];
  clientFilterCtrl: FormControl<string> = new FormControl<string>('');
  filteredPayerList: CustomerModel[] = [];
  disableInputs: boolean = false;
  payerFilterCtrl: FormControl<string> = new FormControl<string>('');


  // formHeight: string = (window.innerHeight - 340) + 'px';

  // @HostListener('window:resize', ['$event'])
  // onResize() {
  //   this.formHeight = (window.innerHeight - 340) + 'px';
  // }


  constructor(
      private labManagerService: LabManagerService,
      private dialog: MatDialog
  ) {
    this.submissionDetailsForm = new FormGroup({
      agronomistUserId: new FormControl(null, [Validators.required]),
      labManLabId: new FormControl(null, [Validators.required]),
      agentLabRef: new FormControl(null),
      otcCustomerDetailId: new FormControl(null, [Validators.required]),
      contactPerson: new FormControl(null),
      contactNumber: new FormControl(null),
      orderAccountId: new FormControl(null, [Validators.required]),
      coopNo: new FormControl(null),
      orderDate: new FormControl(null),
      courier: new FormControl(null),
      waybillNumber: new FormControl(null),
      note: new FormControl(null),
      // A form control like any other, so the chosen address rides out on the same
      // valueChanges the rest of the form uses and is written when the user saves.
      // Nothing about choosing one writes anything on its own.
      otcTenantAddressId: new FormControl(null)
    });

    this.captureFormInputs();
  }
  ngOnInit(): void {
    if(localStorage.getItem('firstTimeLogin')) {
      localStorage.removeItem('firstTimeLogin');
    }
    this.agronomistFilterCtrl.valueChanges.subscribe({
      next: (res) => {
        this.filteredAgronomistList = [...this.agronomistList.filter(a => {
          return a.userIdName.toLowerCase().includes(res.toLowerCase()) || a.userIdSurname.toLowerCase().includes(res.toLowerCase())
        })]
      }
    });

    this.clientFilterCtrl.valueChanges.subscribe({
      next: (res) => {
        this.filteredClientList = this.filterCustomerList(res);
      }
    });

    this.payerFilterCtrl.valueChanges.subscribe({
      next: (res) => {
        this.filteredPayerList = this.filterCustomerList(res);
      }
    });
  }

  filterCustomerList(search: string): CustomerModel[] {
    return [...this.customerList.filter(c => c.name.toLowerCase().includes(search.toLowerCase()))];
  }

  checkCoOp(payer) {
    // console.log(payer)
    // console.log(this.submissionDetailsForm.get('orderAccountId').value)
  }

  /**
   * The client was chosen, by mouse or by keyboard.
   *
   * Driven by the select's (selectionChange), which Material raises for both. It used to hang
   * off a (click) on each option, so selecting with Enter after searching set the value and
   * nothing else: the order account was not defaulted and no customer reached the parent.
   *
   * Reads the form control rather than the event, which is safe because _propagateChanges
   * writes the control before it emits.
   */
  clientDetailChanged() {
    let clientId = this.submissionDetailsForm.get('otcCustomerDetailId').value;

    // The search box lives inside a valueless mat-option. It should never end up selected,
    // but if it ever is, leaving the stored customer alone beats emitting an undefined one.
    if (!clientId) {
      return;
    }

    if(!this.submissionDetailsForm.get('orderAccountId').value) {
      this.submissionDetailsForm.get('orderAccountId').setValue(clientId);
    }
    this.selectedCustomer = this.customerList.find(c => c.id === clientId);
    this.customerChange.emit(this.selectedCustomer);

    // The addresses belong to the client, so they follow it immediately. Any address
    // already chosen belonged to the previous client and is cleared: keeping it would
    // leave the submission pointing at another customer address.
    if (clientId !== this.addressesLoadedFor) {
      this.submissionDetailsForm.get('otcTenantAddressId').setValue(null);
      this.useAltAddress = false;
      this.addressesLoadedFor = clientId;
      this.loadAddresses(clientId);
    }
  }

  captureFormInputs() {
    // Subscribe to form status changes
    this.submissionDetailsForm.valueChanges.subscribe(status => {
      this.labSubmissionDetails = {...this.labSubmissionDetails, ...this.submissionDetailsForm.value};
      // Derived rather than a control of its own: it IS the null case of the picker, and
      // two places holding the same fact would eventually disagree.
      this.labSubmissionDetails.useCustomerDefaultAddress =
          this.submissionDetailsForm.value.otcTenantAddressId == null;
      this.labSubmissionChanges.emit({
        labSubmissionDetails: this.labSubmissionDetails,
        isValid: this.submissionDetailsForm.valid
      });
      // const formData = {...this.submissionDetailsForm.value, creationDate: this.creationDate};
      // this.labManagerSharedDataService.updateLabSubmissionDetails(formData);
    });
  }

  // ==================== customer address ====================

  /** Every address the customer has, the current one first. Empty until loaded. */
  addresses: TenantAddressModel[] = [];

  /**
   * The client the loaded list belongs to.
   *
   * Guards against reloading, and against clearing a chosen address when setSelectedClient
   * runs for the client that is already loaded, which happens on the initial load.
   */
  addressesLoadedFor: number | null = null;
  loadingAddresses = false;

  /**
   * Loads the addresses for the submission customer.
   *
   * Called when the submission arrives rather than when the client dropdown changes: the
   * list belongs to the customer the submission is SAVED against, and offering addresses
   * from a client that has been picked but not saved would let somebody choose one that
   * the submission is about to stop being related to.
   */
  /** The client chosen in the form, which is what the address list follows. */
  get chosenCustomerId(): number | null {
    return this.submissionDetailsForm?.get('otcCustomerDetailId')?.value ?? null;
  }

  /**
   * Loads the addresses for the client currently chosen in the form.
   *
   * NOT the saved client. The address book belongs to the customer, so choosing a client
   * shows that client addresses straight away and changing the client swaps them. Keyed
   * on the saved submission it could only ever show the SAVED client addresses, so a newly
   * chosen client looked like it had none until the form was saved.
   *
   * Choosing one is still only a form change, written when the user saves.
   */
  loadAddresses(customerId: number | null): void {
    if (!customerId) {
      this.addresses = [];
      return;
    }
    this.loadingAddresses = true;
    this.labManagerService.getCustomerAddresses(customerId).subscribe({
      next: res => {
        this.addresses = res?.addresses ?? [];
        // From the FORM, not the response: which address a submission holds is submission
        // state and the form already has it. On rather than off when one is held, so
        // reopening a submission shows the address it will actually print.
        this.useAltAddress = this.submissionDetailsForm.get('otcTenantAddressId')?.value != null;
        this.loadingAddresses = false;
      },
      error: () => {
        // An empty picker, not a broken screen. The address still resolves server side.
        this.addresses = [];
        this.loadingAddresses = false;
      }
    });
  }

  /**
   * Whether the address block can be used at all.
   *
   * THE CLIENT HAS TO BE SAVED FIRST, the same rule the Samples and Analysis Required tabs
   * already follow through hasSavedClient. Samples reference the client, so letting
   * somebody attach things to a client they have not committed to is how a submission ends
   * up holding samples for one client and an address for another.
   *
   * The second half matters as much as the first. Changing the client in the dropdown
   * without saving leaves the form pointing at one client and the submission at another,
   * and the address list belongs to the saved one. Without this check the dropdown would
   * quietly offer the PREVIOUS client addresses, and picking one would attach it here.
   */
  /**
   * Whether the address block can be used.
   *
   * A CLIENT, not a SAVED client. The address book belongs to the customer, so there is
   * nothing to wait for once one is chosen: the list, the choice and adding all work
   * against that customer whether or not the submission has been saved against it yet.
   *
   * This was briefly gated on hasSavedClient, like the Samples tab. That rule exists
   * because samples reference the client, and it does not apply here: an address is not
   * attached to the submission until the form is saved, same as every other field.
   */
  get addressEditable(): boolean {
    return !this.submissionDetailsForm.disabled && this.chosenCustomerId != null;
  }

  /** Why the address block is disabled, or null when it is not. */
  get addressDisabledReason(): string | null {
    if (this.submissionDetailsForm.disabled || this.addressEditable) {
      return null;
    }
    return 'Choose a client to see their addresses.';
  }

  /**
   * Whether the user has asked for an address other than the customer default.
   *
   * Held rather than derived from the chosen id, because a user can turn the toggle on
   * before picking anything, and a derived flag would snap it straight back off.
   *
   * Follows Order Manager, where an order ships to the customer address unless somebody
   * ticks the alternative box.
   */
  useAltAddress = false;

  /** Only the alternatives. The customer own address is what the toggle being off means. */
  get altAddresses(): TenantAddressModel[] {
    return this.addresses.filter(a => !a.current);
  }

  /** The customer own address, shown when the toggle is off. */
  get defaultAddress(): TenantAddressModel | null {
    return this.addresses.find(a => a.current) ?? null;
  }

  /** What will actually be used: the chosen alternative, or the customer default. */
  get selectedAddress(): TenantAddressModel | null {
    const id = this.submissionDetailsForm?.get('otcTenantAddressId')?.value;
    if (id == null) {
      return this.defaultAddress;
    }
    return this.addresses.find(a => a.id === id) ?? null;
  }

  /**
   * Turning the toggle off clears the choice, which is what puts the submission back on
   * the customer default. Still only a form change: nothing is written until Save.
   */
  onUseAltAddressChange(checked: boolean): void {
    this.useAltAddress = checked;
    if (!checked) {
      this.submissionDetailsForm.get('otcTenantAddressId').setValue(null);
    }
  }

  addressLabel(address: TenantAddressModel): string {
    return formatTenantAddress(address);
  }

  /**
   * Types a new address against this customer.
   *
   * Written immediately, because it belongs to the customer rather than to this
   * submission. Selecting it is still only a form change, so the submission is unchanged
   * until the user saves.
   */
  openAddAddress(): void {
    const customerId = this.chosenCustomerId;
    if (!customerId || this.submissionDetailsForm.disabled) {
      return;
    }
    this.dialog.open(AddAddressComponent, { width: '740px', autoFocus: true })
      .afterClosed()
      .subscribe((value: NewTenantAddressModel | null) => {
        if (!value) {
          return;
        }
        this.labManagerService.addCustomerAddress(customerId, value).subscribe({
          next: added => {
            this.addresses = [...this.addresses, added];
            // Selected for them, and the toggle turned on: they just typed it, so
            // anything else would be a second step for no reason. Still only a form
            // change until Save.
            this.useAltAddress = true;
            this.submissionDetailsForm.get('otcTenantAddressId').setValue(added.id);
          }
        });
      });
  }

  checkPayerType() {
    if(this.submissionDetailsForm?.get('orderAccountId')?.value && this.customerList?.length > 0) {
      let selectedCustomer = this.customerList.find(c => c.id === this.submissionDetailsForm?.get('orderAccountId')?.value);
      if(selectedCustomer?.sGrp === 'ZAF') {
        return true;
      }
    }

    return false;
  }

  setSelectedCustomerList() {
    if(this.customerList?.length > 0 && this.submissionDetailsForm.value.otcCustomerDetailId) {
      let index = this.customerList.findIndex(c => c.id === this.submissionDetailsForm.value.otcCustomerDetailId);

      if(index !== -1) {
        this.selectedCustomer = this.customerList[index];
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {

    if(changes?.agronomistList?.currentValue) {
      this.filteredAgronomistList = [...this.agronomistList];
    }

    if(changes?.customerList?.currentValue) {
      this.filteredClientList = [...this.customerList];
      this.filteredPayerList = [...this.customerList];

      this.setSelectedCustomerList();
    }

    if(changes?.labSubmissionDetails?.currentValue && this.capturingChanges) {
      this.creationDate = changes.labSubmissionDetails.currentValue.creationDate;
      this.submissionDetailsForm.setValue({
        agronomistUserId: changes.labSubmissionDetails.currentValue.agronomistUserId,
        labManLabId: changes.labSubmissionDetails.currentValue.labManLabId,
        coopNo: changes.labSubmissionDetails.currentValue.coopNo,
        otcCustomerDetailId: changes.labSubmissionDetails.currentValue.otcCustomerDetailId,
        contactPerson: changes.labSubmissionDetails.currentValue.contactPerson,
        contactNumber: changes.labSubmissionDetails.currentValue.contactNumber,
        orderAccountId: changes.labSubmissionDetails.currentValue.orderAccountId,
        agentLabRef: changes.labSubmissionDetails.currentValue.agentLabRef,
        orderDate: changes.labSubmissionDetails.currentValue?.orderDate ?? this.creationDate,
        courier: changes.labSubmissionDetails.currentValue.courier,
        waybillNumber: changes.labSubmissionDetails.currentValue.waybillNumber,
        note: changes.labSubmissionDetails.currentValue.note,
        // setValue demands every control, so leaving this out would throw rather than
        // quietly skip it.
        otcTenantAddressId: changes.labSubmissionDetails.currentValue.otcTenantAddressId ?? null
      });



      this.setSelectedCustomerList();

      // THE ADDRESSES ON FIRST LOAD.
      //
      // clientDetailChanged is the select (selectionChange) handler, so it only fires when a
      // USER picks a client and never on a page load. Loading there alone left a saved
      // submission with no address, an empty alternatives dropdown and the toggle off even
      // when one was chosen, until the client was re-picked by hand.
      //
      // addressesLoadedFor is set here as well, which is what stops clientDetailChanged
      // clearing the saved choice if it later fires for the client already loaded.
      this.addressesLoadedFor = changes.labSubmissionDetails.currentValue.otcCustomerDetailId ?? null;
      this.loadAddresses(this.addressesLoadedFor);

      this.capturingChanges = false;
    }

    if(changes?.labSubmissionDetails?.currentValue && !this.capturingChanges) {
      if(changes?.labSubmissionDetails?.currentValue?.labManStatusId >= 2) {
        if(!this.disableInputs) {
          this.submissionDetailsForm.disable({ emitEvent: false });
          this.disableInputs = true;
        }

        if(changes.labSubmissionDetails.currentValue.labManStatusId === 4) {
          this.submissionDetailsForm.controls.coopNo.enable({ emitEvent: false });
        }
      } else {
        this.submissionDetailsForm.enable();

        if(this.hasOneAnalysis) {
          this.submissionDetailsForm.controls.labManLabId.disable();
        }

        if(this.hasOneSample) {
          this.submissionDetailsForm.controls.otcCustomerDetailId.disable();
        }
      }
    }
  }



}
